import { Divider } from '@mui/material'
import React from 'react'
import { BiPencil } from 'react-icons/bi'
import { useBancos } from '../../hooks/bancos'
import { PaymentData } from '../../Pages/PagamentoCriar/interfaces'
import { frequenciaCobranca } from '../../utils/frequenciaCobranca'
import { cnpjCpfMask } from '../../utils/masks'
import {
    BillingValue,
    Edit,
    InfoAndEdit,
    InfoAndEdit2,
    InfoPayment,
    ReceiverValue,
    SummarySection,
} from './styles'

interface Props {
    setActiveStep(step: number): void
    getPaymentCommission(valueLink: number): number
    paymentData: PaymentData
    numeroConta: string
}

export default function Step3({
    setActiveStep,
    getPaymentCommission,
    paymentData,
    numeroConta,
}: Props) {
    const { bancos } = useBancos()
    function howTheCustomerWillPay() {
        if (
            paymentData.tipoPagamento === 0 &&
            Number(paymentData.quantParcelas) === 1
        ) {
            return (
                <>
                    <h4>Como você irá pagar</h4>
                    <h5>À vista</h5>
                </>
            )
        }

        if (
            paymentData.tipoPagamento === 0 &&
            Number(paymentData.quantParcelas) > 1
        ) {
            return (
                <>
                    {/* <h4>Como seu cliente irá pagar</h4> */}
                    <h5>Parcelado</h5>
                    <h4>Número máximo de parcelas</h4>
                    <h5>Em até {paymentData.quantParcelas} parcelas</h5>
                </>
            )
        }

        if (paymentData.tipoPagamento === 1) {
            return (
                <>
                    {/* <h4>Como seu cliente irá pagar</h4> */}
                    <h5>Recorrência</h5>
                    <h4>Frequência do pagamento</h4>
                    <h5>
                        {
                            frequenciaCobranca[
                                paymentData.frequenciaPagamento as keyof typeof frequenciaCobranca
                            ]
                        }
                    </h5>
                </>
            )
        }
    }

    const commissionValue = getPaymentCommission(Number(paymentData.valor))
    const total = (Number(paymentData.valor) + commissionValue).toFixed(2)

    return (
        <>
            <SummarySection>
                <h2 className="title">
                    Confira seus dados para finalizar o pagamento
                </h2>

                <InfoPayment>
                    <InfoAndEdit>
                        <h2>Informações do pagamento</h2>
                        <Edit onClick={() => setActiveStep(0)}>
                            <BiPencil size={16} color="#0030B9" />
                            <span>Editar</span>
                        </Edit>
                    </InfoAndEdit>

                    <h4>Valor do pagamento</h4>
                    <h5>
                        {Number(paymentData.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </h5>

                    <div className="flex items-center justify-between">
                        <h4>Nome do recebedor</h4>
                        <h5>{paymentData.nomeTitular}</h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>CPF/CNPJ do recebedor</h4>
                        <h5>
                            {cnpjCpfMask(paymentData.numeroDocumentoTitular)}
                        </h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>Banco</h4>
                        <h5>{bancos[paymentData.compe]}</h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>Agência</h4>
                        <h5>{paymentData.agencia}</h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>Número da conta</h4>
                        <h5>{numeroConta}</h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>Tipo da conta</h4>
                        <h5>{paymentData.tipoConta}</h5>
                    </div>
                    <div className="flex items-center justify-between">
                        <h4>Email</h4>
                        <h5>{paymentData.email}</h5>
                    </div>

                    <InfoAndEdit2>
                        <h2>Forma de Pagamento</h2>
                        <Edit onClick={() => setActiveStep(1)}>
                            <BiPencil size={16} color="#0030B9" />
                            <span>Editar</span>
                        </Edit>
                    </InfoAndEdit2>

                    {howTheCustomerWillPay()}

                    <BillingValue>
                        {/* <div>
                            <h4>Valor da Cobrança</h4>
                            <h5>{Number(linkData.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h5>
                        </div> */}
                        <div>
                            <h4>Valor do serviço Tree</h4>
                            <h5>
                                {Number(commissionValue).toLocaleString(
                                    'pt-br',
                                    { style: 'currency', currency: 'BRL' }
                                )}
                            </h5>
                        </div>
                    </BillingValue>

                    {/* <BillingValue>
                        <div>
                            <h4>Valor da comissão</h4>
                            <h5>- {Number(commissionValue).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h5>
                        </div>
                    </BillingValue> */}

                    <Divider style={{ marginTop: 10, marginBottom: 10 }} />

                    <ReceiverValue>
                        <h4>Valor total do pagamento</h4>
                        <h3>
                            {Number(total).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </h3>
                    </ReceiverValue>
                </InfoPayment>
            </SummarySection>
        </>
    )
}
